/**
 * Helper: Breakpoints
 * -----------------------------------------------------------------------------
 * Global configuration for consistent values for media queries in scripts.
 * These values should mirror the breakpoint values defined in `grid.scss`.
 */
export default {
    tiny: '320px',
    small: '480px',
    medium: '768px',
    large: '992px',
    wide: '1200px'
}



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/breakpoints.js